/**
 * Urls to include errors for datadog. Be as board or specific as needed
 */
export const dataDogUrlErrorWhitelist = [
    'sunnyside.co',
    'joinsunnysidemed.com'
];
